import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  ILoadServicesListInt,
  ILoadServicesListIntSuccessAction,
  LoadServicesListErrorAction,
} from '../actions/load-services-list-filter-int'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'

export type LoadServicesListFilterInt =
  | ILoadServicesListInt
  | ILoadServicesListIntSuccessAction
  | LoadServicesListErrorAction

const init = (state: IServicePerformanceState, action: LoadServicesListFilterInt) => ({
  ...state,
  servicesListFilterInt: {
    ...initialState.servicesListFilterInt,
    status: action.status,
  },
})

const success = (state: IServicePerformanceState, action: LoadServicesListFilterInt) => ({
  ...state,
  servicesListFilterInt: {
    ...initialState.servicesListFilterInt,
    status: action.status,
    data: {
      services: (action as ILoadServicesListIntSuccessAction).data.services,
      filteredSites: (action as ILoadServicesListIntSuccessAction).data.filteredSites,
      adaptiveNetworkCountries: (action as ILoadServicesListIntSuccessAction).data
        .adaptiveNetworkCountries,
      adaptiveNetworkServiceTypes: (action as ILoadServicesListIntSuccessAction).data
        .adaptiveNetworkServiceTypes,
    },
  },
})

const failure = (state: IServicePerformanceState, action: LoadServicesListFilterInt) => ({
  ...state,
  servicesListFilterInt: {
    ...initialState.servicesListFilterInt,
    status: action.status,
    error: (action as LoadServicesListErrorAction).error,
  },
})

export const loadServicesListReducerInt = createAsyncReducer(initialState, init, success, failure)
